import { GOOGLE_TTS_API_KEY } from './constants';

export const synthesizeSpeech = async (text, name = 'en-US-Wavenet-F') => {
  const API_KEY = GOOGLE_TTS_API_KEY;
  const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${API_KEY}`;
  const body = {
    input: { text: text },
    voice: { languageCode: 'ar-XA', name: name },
    audioConfig: { audioEncoding: 'MP3' },
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();
    return result; // contains audioContent (base64 MP3)
  } catch (error) {
    console.error('Error synthesizing speech:', error);
    throw error;
  }
};

export function stripTags(input) {
  if (!input) return '';
  return input.replace(/<\/?[^>]+(>|$)/g, '');
}